import { IntlShape } from 'gatsby-plugin-intl';

import { isEmailValid } from 'utils/form';

import { NewsletterFormValidationResult, NewsletterFormValues } from '../types';

export const buildNewsletterFormValidator =
  ({ formatMessage }: IntlShape) =>
  (values: NewsletterFormValues): NewsletterFormValidationResult => {
    const validationResult: NewsletterFormValidationResult = {};

    if (!values.email?.trim()) {
      validationResult.email = formatMessage({ id: 'validations.field-required' });
    } else if (!isEmailValid(values.email)) {
      validationResult.email = formatMessage({ id: 'validations.invalid-email' });
    }

    return validationResult;
  };
